import ApplicationDescription from './ApplicationDescription';
export { ApplicationDescription };
export default ApplicationDescription;
